const themeConfiguration = {
    version: "3.3",
    theme: "light",
    contentWidth: "full",
    sidebarCollapsed: false,
    sidebarCollapseButton: true,
    layout: "VerticalLayout",
    navigationFull: false,
    navigationBg: false,
    direction: "ltr",
    language: "en",
};

export default themeConfiguration;